import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import api, { authHeaders } from "@/lib/api";

export default function SettingsTab() {
  const [form, setForm] = useState(null);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api.get("/admin/config", { headers: authHeaders() }).then(({ data }) => setForm({
      phone: data.phone || "", whatsapp_number: data.whatsapp_number || "", email: data.email || "",
      address: data.address || "", working_hours: data.working_hours || "",
      social_facebook: data.social_facebook || "", social_instagram: data.social_instagram || "",
      social_tiktok: data.social_tiktok || "", social_youtube: data.social_youtube || "",
      legal_cui: data.legal_cui || "", legal_registry: data.legal_registry || "",
      project_categories: (data.project_categories || []).join("\n"),
      seo_title: data.seo_title || "", seo_description: data.seo_description || "",
    }));
  }, []);

  if (!form) return <p className="text-sm text-muted-foreground">Se încarcă...</p>;

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    await api.put("/admin/config", {
      ...form,
      project_categories: form.project_categories.split("\n").map((x) => x.trim()).filter(Boolean),
    }, { headers: authHeaders() });
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  };

  return (
    <form onSubmit={save} className="max-w-3xl space-y-5" data-testid="admin-settings-tab">
      <div className="border border-copper/40 bg-copper/5 p-5 text-sm leading-relaxed text-copper" data-testid="admin-settings-hint">
        Datele de contact de aici apar pe site (pagina Contact, footer). Pentru WhatsApp scrie numărul în
        format internațional, fără „+" — de exemplu: 40712345678.
      </div>
      <div className="grid gap-5 sm:grid-cols-2">
        <div>
          <label className="label-brox">Telefon</label>
          <input className="input-brox" value={form.phone} onChange={set("phone")} data-testid="admin-settings-phone" />
        </div>
        <div>
          <label className="label-brox">Număr WhatsApp (ex: 40712345678)</label>
          <input className="input-brox" value={form.whatsapp_number} onChange={set("whatsapp_number")} data-testid="admin-settings-whatsapp" />
        </div>
        <div>
          <label className="label-brox">Email</label>
          <input className="input-brox" type="email" value={form.email} onChange={set("email")} data-testid="admin-settings-email" />
        </div>
        <div>
          <label className="label-brox">Program de lucru (o linie pe zi)</label>
          <textarea
            className="input-brox min-h-[100px] resize-none"
            placeholder={"Ex:\nLuni – Vineri: 08:00 – 19:00\nSâmbătă: 08:00 – 14:00\nDuminică: Închis"}
            value={form.working_hours}
            onChange={set("working_hours")}
            data-testid="admin-settings-hours"
          />
        </div>
        <div className="sm:col-span-2">
          <label className="label-brox">Adresă firmă</label>
          <input className="input-brox" value={form.address} onChange={set("address")} data-testid="admin-settings-address" />
        </div>
        <div>
          <label className="label-brox">Facebook (URL)</label>
          <input className="input-brox" placeholder="https://facebook.com/..." value={form.social_facebook} onChange={set("social_facebook")} data-testid="admin-settings-facebook" />
        </div>
        <div>
          <label className="label-brox">Instagram (URL)</label>
          <input className="input-brox" placeholder="https://instagram.com/..." value={form.social_instagram} onChange={set("social_instagram")} data-testid="admin-settings-instagram" />
        </div>
        <div>
          <label className="label-brox">YouTube (URL)</label>
          <input className="input-brox" placeholder="https://youtube.com/..." value={form.social_youtube} onChange={set("social_youtube")} data-testid="admin-settings-youtube" />
        </div>
        <div>
          <label className="label-brox">TikTok (URL)</label>
          <input className="input-brox" placeholder="https://tiktok.com/@..." value={form.social_tiktok} onChange={set("social_tiktok")} data-testid="admin-settings-tiktok" />
        </div>
        <div>
          <label className="label-brox">CUI (opțional — apare în paginile legale)</label>
          <input className="input-brox" value={form.legal_cui} onChange={set("legal_cui")} data-testid="admin-settings-cui" />
        </div>
        <div>
          <label className="label-brox">Registrul Comerțului (opțional)</label>
          <input className="input-brox" value={form.legal_registry} onChange={set("legal_registry")} data-testid="admin-settings-registry" />
        </div>
        <div>
          <label className="label-brox">Categorii proiecte (una pe linie)</label>
          <textarea className="input-brox min-h-[100px] resize-none" value={form.project_categories} onChange={set("project_categories")} data-testid="admin-settings-categories" />
        </div>
        <div className="sm:col-span-2">
          <label className="label-brox">SEO — titlu implicit</label>
          <input className="input-brox" value={form.seo_title} onChange={set("seo_title")} data-testid="admin-settings-seotitle" />
        </div>
        <div className="sm:col-span-2">
          <label className="label-brox">SEO — descriere implicită</label>
          <textarea className="input-brox min-h-[90px] resize-none" value={form.seo_description} onChange={set("seo_description")} data-testid="admin-settings-seodesc" />
        </div>
      </div>
      <div className="flex items-center gap-4">
        <button type="submit" className="btn-primary" data-testid="admin-settings-save">SALVEAZĂ SETĂRILE</button>
        {saved && <span className="flex items-center gap-2 font-mono text-xs uppercase tracking-wider text-wa" data-testid="admin-settings-saved"><Check className="h-4 w-4" />Salvat</span>}
      </div>
    </form>
  );
}
